import {
  UPDATE_LIVESTREAMS,
  EVENT_HAS_TIIVII_OTT_CONFIG,
  EVENT_HAS_TIIVII_RTMP_CONFIG,
  EVENT_SHOW_DELETED,
  STORE_DEPLOYMENT_SOURCES,
  STORE_EVENT_TO_COPY,
} from "../actions/action-types";

const INITIAL_STATE = {
  liveStreams: [],
  hasTiiviiOttConfig: null,
  sourceList: [],
  showDeletedEvents: false,
  eventToCopy: null,
};

function commonState(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_LIVESTREAMS:
      return { ...state, liveStreams: action.data };
    case EVENT_HAS_TIIVII_OTT_CONFIG:
      return { ...state, hasTiiviiOttConfig: action.data };
    case EVENT_HAS_TIIVII_RTMP_CONFIG:
      return { ...state, hasTiiviiRtmpConfig: action.data };
    case EVENT_SHOW_DELETED: {
      return { ...state, showDeletedEvents: action.data };
    }
    case STORE_DEPLOYMENT_SOURCES: {
      return { ...state, sourceList: action.data?.sources?.items };
    }
    case STORE_EVENT_TO_COPY: {
      return { ...state, eventToCopy: action.data };
    }
    default:
      return state;
  }
}

export default commonState;
